import React, {useEffect, useMemo, useRef, useState, forwardRef} from 'react';
import styles from './Tree/components/TreeItem/TreeItem.module.css';

export const TaskTextField = forwardRef(function TaskTextField( props, ref) {
         const {title,
                onTitleChange,
                handleOnFocus,
                onMouseEnter,
                onMouseLeave,
                onUpArrowPressed,
                onDownArrowPressed,
                inputRefs,
                index,
                textFieldCharacterLength = 70,
                goal = false} = props;  

  const [inputText, setInputText] = useState(title);

  function handleClick(e) { 

    handleChange(e);
    handleOnFocus(false);
  
  }

  function handleCtrlEnterPressed(e) { 

    handleChange(e);
    handleOnFocus(true);
    
  }

  function handleUpArrowPressed(e) { 

    handleChange(e);
    onUpArrowPressed && onUpArrowPressed();
  }

  function handleDownArrowPressed(e) { 

    handleChange(e);
    onDownArrowPressed && onDownArrowPressed();
    
  }

  function handleChange(e) {
    // e.preventDefault();

    console.log("handleChange inputRef: "+inputRefs.current[index].getAttribute('value'))
    inputRefs.current[index].readOnly = true;
    inputRefs.current[index].style.pointerEvents = 'none';

    if(onTitleChange) {
      if(e.relatedTarget) {
        onTitleChange(inputText, null);
      }
      else {
        onTitleChange(inputText, null);
      }
      
    }
  }

  function handleOnKeyDown(e) {
    // e.preventDefault();
    console.log('Hit and released: ', e.key);
    if(e.key === 'Enter' && e.ctrlKey) {
      console.log('Hit and released ctrl+enter', e.key, e.ctrlKey);
      handleCtrlEnterPressed(e)
    }
    else if(e.key === 'ArrowUp') {
      console.log('User hit and released "up arrow" key', e.key);
      const previousIndex = index - 1;
      const nextInput = inputRefs?.current[previousIndex];

      if (nextInput) {
        nextInput.focus();
      }

      handleUpArrowPressed(e)
    }
    else if(e.key === 'ArrowDown') {
      console.log('User hit and released "down arrow" key', e.key);

      const nextIndex = index + 1;
      const nextInput = inputRefs?.current[nextIndex];

      if (nextInput) {
        nextInput.focus();
      }

      handleDownArrowPressed(e);
    }
  }

  const handlePointerDown = (e) => {
    // Read the metal hardware directly via your nativeEvent lookups
    const hardwareType = e.pointerType || e.nativeEvent?.pointerType;

    console.log("on handleClick inputRef: "+inputRefs.current[index].getAttribute('value'));

    if (hardwareType === 'touch') {
      // 📱 MOBILE BEHAVIOR:
      if (inputRefs.current[index].readOnly) {
        // First touch: Stop the event bubble from leaking up to your root state lists
        e.stopPropagation();
        
        // if(inputRefs){(inputRefs.current[index]?.blur() );}
        // Mark the field as primed/unlocked for the NEXT interaction
        // isUnlockedRef.current = true;
        inputRefs.current[index].readOnly = false;
        inputRefs.current[index].style.pointerEvents = 'auto';
        // if(inputRefs){(inputRefs.current[index].disabled = false );}
        
        console.log("📱 First touch intercepted. Focus blocked, input primed.");
      } else {
        // Second touch: They are intentionally clicking the primed text area.
        // Let the standard event cascade proceed normally to focus the text.
        // e.stopPropagation();
        console.log("📱 Second touch verified. Allowing native focus.");
      }
    } else {
      // 💻 DESKTOP BEHAVIOR: Standard mouse clicks bypass the lock completely
      inputRefs.current[index].readOnly = false;
      inputRefs.current[index].style.pointerEvents = 'auto';

    }
  };

  const handleMouseEnters = (e) => {
      
      const hardwareType = e.pointerType || e.nativeEvent?.pointerType;

      // console.log("Handling mouse entering span. pointerType: "+hardwareType);

      if (hardwareType === 'mouse') {
        // console.log("on handleClick inputRef: "+inputRefs?.current[index].getAttribute('value'));
        inputRefs.current[index].style.pointerEvents = 'auto';
        inputRefs.current[index].readOnly = false;
        // console.log("Span interactivity set correctly.");
      }
  };

  const handleFocus = (e) => {

    const hardwareType = e.pointerType || e.nativeEvent?.pointerType;

    // 🛑 THE ANCHOR CURE: If a mobile target fuzzing gesture tries to force 
    // focus on the first touch, violently strip focus away immediately.
    if (hardwareType === 'touch') {
      // e.stopPropagation();
      // e.preventDefault();
      console.log("handleFocus inputRef: "+inputRefs.current[index].getAttribute('value'))
      inputRefs.current[index].style.pointerEvents = 'none';
      // if(inputRefs){(inputRefs.current[index]?.blur() );}
      // if(inputRefs){(inputRefs.current[index].disabled = true );}
      // if(inputRefs){(inputRefs.current[index].disabled = false );}
      // inputRef.current?.blur(); // Force the browser to drop the caret & hide soft keyboard
      return;
    }
    else {
      inputRefs.current[index].style.pointerEvents = 'auto';
    }
  };

  // const handleBlur = () => {
  //   // Reset the lock when the user clicks completely away from the task row
  //   isUnlockedRef.current = false;
  // };

  return(
    <span  className={styles.Text}
           onMouseEnter={onMouseEnter}
           onMouseLeave={onMouseLeave}
           onPointerEnter={(e) => handleMouseEnters(e)}
          //  onMouseOver={(e) => handleFocus(e)}
           tabIndex="-1"
           onClick={e=> handlePointerDown(e)}
           onBlur={e => handleChange(e)}
           onFocus={ (e) => handleFocus(e)}
           >
      <form padding="25xp" method="post" onSubmit={handleClick}>
        {goal && (
          // <label padding="25px">New Goal Title:  
              <span>
                <input className={styles.Text} 
                       name="goalTitle" 
                       value={inputText} 
                       onChange={e => setInputText(e.target.value)}
                       onBlur={e => handleChange(e)}
                       placeholder={title}
                       size="70"
                       type="text"
                       ref={ref}
                />
              </span>
              
              // <button type="submit">Add Goal</button>
          // </label>
        )}
        {!goal && (
          // <label padding="25px">New Task Title:  
          <span className={styles.Text}>
            <input className={styles.Text}
                   name="taskTitle" 
                   value={inputText} 
                   onClick={handlePointerDown}
                   onChange={e => setInputText(e.target.value)}
                   onBlur={e => handleChange(e)}
                  //  onFocusOut={e => handleOnBlurCapture(e)}
                   onKeyDown={e => handleOnKeyDown(e)}
                  //  readOnly={true}//{!isUnlockedRef.current} // Blocks text field activation/selection bounds completely
                  //  inputMode={'none'}//{!isUnlockedRef.current ? 'none' : 'text'} // Prevents the mobile virtual keyboard from flickering open
                   placeholder={title}                   
                   size={textFieldCharacterLength}
                   type="text"
                   ref={ (el) => {
                          if (el && el.offsetParent) {if(inputRefs){(inputRefs.current[index] = el)}};
                        }}
                   style={{
                    // 🛡️ THE PERFECT INITIAL SHIELD: The first mobile touch down 
                    // cannot trigger target fuzzing because it can't feel this element.
                    pointerEvents: 'none', 
                    borderRadius: '3px',
                    borderWidth: 0,
                    ...props.style
                   }}
            />
          </span>
            // <button type="submit">Add Task</button>
          // </label>
        )}
      </form>
    </span>
  );

});

export default TaskTextField;